import { apiFetch } from "../client.js";

/**
 * @typedef {Object} SendTextOptions
 * @property {unknown=} quotedKey
 * @property {string|number=} accountSessionId
 * @property {string|number=} leadId
 * @property {string=} phone
 * @property {string=} displayName
 */

/**
 * @param {string} chatJid
 * @param {string} text
 * @param {unknown|SendTextOptions|null} [quotedKeyOrOptions]
 * @returns {Promise<any>}
 */
export async function sendText(chatJid, text, quotedKeyOrOptions = null) {
  const options = isSendTextOptions(quotedKeyOrOptions)
    ? quotedKeyOrOptions
    : { quotedKey: quotedKeyOrOptions };
  const body = { chatJid, text };
  if (options.quotedKey) body.quotedKey = options.quotedKey;
  for (const key of ["accountSessionId", "leadId", "phone", "displayName"]) {
    const value = options[key];
    if (value !== undefined && value !== null && String(value).trim()) {
      body[key] = String(value);
    }
  }
  return apiFetch("/whatsapp/messages/text", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

function isSendTextOptions(value) {
  return !!value
    && typeof value === "object"
    && !Array.isArray(value)
    && (
      Object.prototype.hasOwnProperty.call(value, "quotedKey")
      || Object.prototype.hasOwnProperty.call(value, "accountSessionId")
      || Object.prototype.hasOwnProperty.call(value, "leadId")
      || Object.prototype.hasOwnProperty.call(value, "phone")
      || Object.prototype.hasOwnProperty.call(value, "displayName")
    );
}

export async function sendMedia({ chatJid, kind, file, caption = "", ptt = false }) {
  const mediaBase64 = await fileToBase64(file);
  return apiFetch("/whatsapp/messages/media", {
    method: "POST",
    body: JSON.stringify({
      chatJid,
      kind,
      mediaBase64,
      mimetype: file.type || "",
      caption,
      ptt,
    }),
  });
}

export async function sendDocument({ chatJid, file, caption = "" }) {
  const mediaBase64 = await fileToBase64(file);
  return apiFetch("/whatsapp/messages/document", {
    method: "POST",
    body: JSON.stringify({
      chatJid,
      fileName: file.name || "documento.bin",
      mediaBase64,
      mimetype: file.type || "",
      caption,
    }),
  });
}

export async function sendReaction(chatJid, messageKey, emoji) {
  return apiFetch("/whatsapp/messages/reaction", {
    method: "POST",
    body: JSON.stringify({ chatJid, messageKey, emoji }),
  });
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(String(reader.result || ""));
    };
    reader.onerror = () => reject(reader.error || new Error("file read failed"));
    reader.readAsDataURL(file);
  });
}
